function init() {
    let container = document.querySelector(".translucent-header");
    if (!container) return;

    let imageContainer = container.querySelector(".container-image-list");
    let videoElement = container.querySelector(".hero__video");
    // let images = imageContainer.querySelectorAll("img");
    let images = imageContainer ? imageContainer.querySelectorAll("img") : [];

    let currentIndex = 0;
    let isPaused = false;

    const playButton = container.querySelector("#playButton");
    const pauseButton = container.querySelector("#pauseButton");
    let intervalId;

    function showImage(index) {
        images.forEach((img, i) => {
            img.classList.toggle("active", i === index);
        });
    }

    function startSlideshow() {
        intervalId = setInterval(() => {
            currentIndex = (currentIndex + 1) % images.length;
            showImage(currentIndex);
        }, 3000);
    }

    function stopSlideshow() {
        clearInterval(intervalId);
    }

    function toggleButtons() {
        playButton.classList.toggle("hidden", !isPaused);
        pauseButton.classList.toggle("hidden", isPaused);
    }

    function togglePlayback() {
        if (videoElement) {
            if (isPaused) {
                videoElement.play();
            } else {
                videoElement.pause();
            }
        }
    }
    if (images.length == 1) {
        let imageUrl = images[currentIndex].src;
        container.style.backgroundImage = `url(${imageUrl})`;
        playButton.classList.add("hidden");
        pauseButton.classList.add("hidden");
    } else if (images.length > 1) {
        showImage(currentIndex);
        startSlideshow();

        playButton.classList.add("hidden");

        playButton.addEventListener("click", () => {
            if (isPaused) {
                startSlideshow();
                togglePlayback();
                isPaused = false;
                toggleButtons();
            }
        });

        pauseButton.addEventListener("click", () => {
            if (!isPaused) {
                stopSlideshow();
                togglePlayback();
                isPaused = true;
                toggleButtons();
            }
        });
    } else if (videoElement) {
        playButton.classList.add("hidden");

        playButton.addEventListener("click", () => {
            if (isPaused) {
                videoElement.play();
                isPaused = false;
                toggleButtons();
            }
        });

        pauseButton.addEventListener("click", () => {
            if (!isPaused) {
                videoElement.pause();
                isPaused = true;
                toggleButtons();
            }
        });
    }
}

export default { init };
